// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_-Zrin clearfix","list":"index_list_q3160"};